import { render } from "./Signup-Page.vue?vue&type=template&id=1dce6094&scoped=true"
import script from "./Signup-Page.vue?vue&type=script&lang=js"
export * from "./Signup-Page.vue?vue&type=script&lang=js"

import "./Signup-Page.vue?vue&type=style&index=0&id=1dce6094&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dce6094"]])

export default __exports__